import { useState } from 'react';
import {
  Box, Button, Modal, Typography, Fade,
} from '@mui/material';
import { logos } from '../../utils/logos.js';
import { styles } from '../../assets/styles';

export default function StatsButton({ statsKey }) {
  const [open, setOpen] = useState(false);

  const statsJson = localStorage.getItem(statsKey);
  const stats = statsJson ? JSON.parse(statsJson) : 0;
  const wincount = stats ? stats.winCount : 0;
  const avgguesses = stats ? stats.avgGuesses : 0;

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [isHoveringStats, setIsHoveringStats] = useState(false);

  const handleMouseOverStats = () => {
    setIsHoveringStats(true);
  };

  const handleMouseOutStats = () => {
    setIsHoveringStats(false);
  };

  return (
    <>
      <Button
        disableRipple
        className="stats-icon-button"
        onMouseOver={handleMouseOverStats}
        onMouseOut={handleMouseOutStats}
        onClick={handleOpen}
        sx={styles.statsButton}
      >
        <img src={logos.statsLogoGolden} alt="Stats Logo" />

        {isHoveringStats && <Box sx={styles.buttonHoverBox}>Trainer info</Box>}
      </Button>

      <Modal open={open} onClose={handleClose} style={styles.modalOpenStats}>
        <Fade in={open}>
          <Box sx={styles.statsBox1}>
            <Box sx={styles.statsBox2}>
              <Box sx={styles.statsBox3}>
                <Typography variant="h4" sx={styles.statsTypography}>
                  TRAINER INFO
                  <Box>
                    <img src={logos.redPng} alt="Red.png" style={styles.trainerInfoBoxMargin} />
                  </Box>
                </Typography>
                <Box sx={styles.trainerInfoBoxContainer}>
                  <div style={styles.boxInlineBackground}>
                    <Typography variant="h4" sx={styles.statsInlineTypography}>
                      Games won:
                      {' '}
                      <span style={styles.trainerInfoSpan}>{wincount}</span>
                    </Typography>
                  </div>
                </Box>
                <Box sx={styles.trainerInfoBoxContainer}>
                  <div style={styles.boxInlineBackground}>
                    <Typography variant="h4" sx={styles.statsInlineTypography}>
                      Average guesses:
                      {' '}
                      <span style={styles.trainerInfoSpan}>{avgguesses}</span>
                    </Typography>
                  </div>
                </Box>
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}
